import React, { useEffect } from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faComments } from '@fortawesome/free-solid-svg-icons';
import Cookies from 'js-cookie';

const SignupServiceInfo = () => {
    const iconStyle = {
        marginRight: '.5rem',
    };

    const isWidgetEnabled = process.env.REACT_APP_ENABLE_ATLASSIAN_WIDGET === 'true' && Cookies.get('bigfoot_personalization-consent') === 'true';
    return (
        <>
            <h2>Fragen zum Bewerbungsprozess?</h2>
            {isWidgetEnabled ? (
                <>
                    <p>Unser <strong>digitaler Assistent</strong> ist jederzeit für Sie da. Falls er einmal nicht weiterweiß, können Sie Ihr Anliegen direkt über den Chat an unser Team übermitteln. Klicken Sie auf <strong>Hilfe-Chat öffnen</strong>, um zu starten.</p>
                    <span className="visually-hidden">
                        Erreichbar per Telefon unter der Nummer 0221 677 746 83 oder per E-Mail unter der Adresse hilfe@projektbigfoot.de.
                    </span>
                </>
            ) : (
                <>
            <p>
                Kontaktieren Sie uns <strong>werktags von 9:00 bis 17:00 Uhr</strong> via
                Telefon oder E-Mail.
            </p>
                <a
                    className="anl_signup--telephone-number d-block"
                    href="tel:+4922167774683"
                >
                    <FontAwesomeIcon
                        icon={faPhone}
                        style={iconStyle}
                        fixedWidth
                    />
                    <span className="visually-hidden">
                        Erreichbar per Telefon mit der Nummer:
                    </span>
                    0221 677 746 83
                </a>
                <a
                    className="anl_signup--email d-block mt-2"
                    href="mailto:hilfe@new-vereinsfoerderung.de"
                >
                    <FontAwesomeIcon
                        icon={faEnvelope}
                        style={iconStyle}
                        fixedWidth
                    />
                    <span className="visually-hidden">
                        Oder per E-Mail mit der Adresse:
                    </span>
                    hilfe@new-vereinsfoerderung.de
                </a>
                </>
            )}
        </>
    );
};

export default SignupServiceInfo;